import { ISuggestionsState, ESuggestionsStatus } from '../../../types/filters';

export const defaultState: ISuggestionsState = {
  status: ESuggestionsStatus.Initial,
  suggestions: {},
  sortOrder: [],
};
